module.exports = __webpack_public_path__ + "img/uploader.0c23f41f.svg";